import { ClientSecretDto } from "@merchant_api/models/client-secret-dto";

export class ClientSecretsState {
    loading = false;
    error = null;
    record: Array<ClientSecretDto> = [];
}
